import { ContentPage } from '../page-factory/content-page';
import { mauniAmavasyaPage } from '../pages/page-magh-mela.bathing-dates';
import { MetaFunction } from '@remix-run/cloudflare';

export const meta: MetaFunction = () => {
  return [
    { title: 'Mauni Amavasya - Magh Mela 2026 - Kumbh Sukrit' },
    {
      name: 'description',
      content:
        'Observe Mauni Amavasya, the most significant bathing day of Magh Mela 2026. Experience the power of silence and sacred bathing.',
    },
    {
      tagName: 'link',
      rel: 'canonical',
      href: 'https://kumbhsukrit.com/magh-mela-2026/mauni-amavasya',
    },
  ];
};

export default function MauniAmavasyaPage() {
  return <ContentPage {...mauniAmavasyaPage} />;
}
